import React from 'react';
import ReactDOM from 'react-dom/client';
import { ClerkProvider } from '@clerk/clerk-react';
import './index.css';
import App from './App';

// Get the publishable key from environment variables
const PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY || '';

// Debug: Log the key status (first 10 chars only for security)
if (!PUBLISHABLE_KEY) {
  console.error('❌ REACT_APP_CLERK_PUBLISHABLE_KEY is not set. Clerk authentication will not work.');
  console.error('Please set REACT_APP_CLERK_PUBLISHABLE_KEY in Vercel Dashboard → Settings → Environment Variables');
} else {
  console.log('✅ Clerk Publishable Key loaded:', PUBLISHABLE_KEY.substring(0, 10) + '...');
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Only render ClerkProvider if we have a key, otherwise show error
if (!PUBLISHABLE_KEY) {
  root.render(
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      flexDirection: 'column',
      gap: '1rem',
      padding: '2rem',
      textAlign: 'center'
    }}>
      <h1 style={{ color: '#dc2626' }}>⚠️ Clerk Configuration Error</h1>
      <p style={{ color: '#6b7280', maxWidth: '600px' }}>
        REACT_APP_CLERK_PUBLISHABLE_KEY is not set in environment variables.
      </p>
      <p style={{ color: '#6b7280', maxWidth: '600px' }}>
        Please set this variable in Vercel Dashboard → Settings → Environment Variables, then redeploy.
      </p>
      <code style={{
        backgroundColor: '#f3f4f6',
        padding: '0.5rem 1rem',
        borderRadius: '0.375rem',
        fontSize: '0.875rem'
      }}>
        REACT_APP_CLERK_PUBLISHABLE_KEY=pk_test_...
      </code>
    </div>
  );
} else {
  root.render(
    <React.StrictMode>
      <ClerkProvider publishableKey={PUBLISHABLE_KEY}>
        <App />
      </ClerkProvider>
    </React.StrictMode>
  );
}
